/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import Header from "./NavbarPage/NavbarPage";
import SEO from "./Base/SEO";

const Layout = (props: { children: any; title: string }) => {
  return (
    <>
      <SEO title={props.title} />
      <Header />
      <main style={{ backgroundColor: "#f7fafc" }}>{props.children}</main>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
